export default __webpack_public_path__ + "static/media/Header2.65e54e6b.gif";